import { Anchor, Stack, Text } from "@mantine/core";
import { Link } from "react-router";
import { AuthCard } from "./AuthCard";

/** After "Delete my account" (spec §5.4; Figma 15185:4973). */
export function DeletedPage() {
  return (
    <AuthCard title="Your account is deleted">
      <Stack gap={8}>
        <Text lh={1.25}>
          Your SlideBrain account and the data tied to it have been deleted. SlideBrain inside PowerPoint won't sign you in
          with this email anymore.
        </Text>
        <Text lh={1.25}>
          Changed your mind?{" "}
          <Anchor component={Link} to="/sign-up" fw={400}>
            Create a new account
          </Anchor>
        </Text>
      </Stack>
    </AuthCard>
  );
}
